import React from 'react'
import { cn } from '../../utils/cn'

interface Props {
  onClick: () => void
  label: string
  className?: string
}

const GhostButton = ({ onClick, label, className }: Props) => {
  return (
    <button
      onClick={onClick}
      type='button'
      className={cn(
        'hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-9 px-4 py-2',
        className,
      )}
    >
      {label}
    </button>
  )
}

export default GhostButton
